import type { ReactNode } from "react";
import { Separator } from "@/components/ui/separator";

/**
 * Shared shell for workout builder pages.
 *
 * Keeps:
 * - full-height flex column structure
 * - consistent premium background
 * - header area separated from scrollable main content
 */
export default function BuilderShell({
  header,
  children,
}: {
  header: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="h-full flex flex-col bg-gradient-to-br from-slate-50 via-white to-slate-100 text-gray-900">
      {header}
      <Separator />
      <div className="flex-1 min-h-0">{children}</div>
    </div>
  );
}

